<template>
  <div class="loading-div">
    <van-loading vertical>请求中...</van-loading>
  </div>
</template>
 
<script>
  export default {
    name: 'Loading',
    data () {
      return {}
    },
  }
</script>
<style scoped>
	.loading-div {
		padding-top: 100px;
		width: 100%;
		height: 100vh;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 10001;
		background-color:rgba(0,0,0,0.5)
	}
	
	.loading-div /deep/ .van-loading__spinner {
		width: 100px;
		height: 100px;
		color: #ffffff;
	}
	
	.loading-div /deep/ .van-loading__text {
		margin-top: 20px;
		font-size: 20px;
		color: #ffffff;
	}
</style>